export default __webpack_public_path__ + "static/media/header-icon.22164e76.png";